<div class="flex w-full min-w-0 flex-col">
  @if (layout() !== 'wide') {
    <proffeo-task-details-mobile-metadata
      (statusSelected)="onStatusSelected($event)"
      (progressSelected)="onPercentageChange($event)"
      (prioritySelected)="onPrioritySelected($event)"
      (industryRequested)="onIndustryClicked()"
      (locationRequested)="onLocationClicked()"
      (openTimeReportRequested)="openTimeReportClicked()"
      (timeReportsTabRequested)="timeReportsTabClicked()"
      (startDateSelected)="onTaskStartDateSelected($event)"
      (endDateSelected)="onTaskEndDateSelected($event)"
      (estimationSelected)="onEstimationSelected($event)"
      (groupRequested)="onChangeGroupClicked()"
      (participantsRequested)="onChangeParticipantsClicked()"
      (tagsRequested)="openTaskTagsEditor()"
      [task]="task()"
      [tags]="tags()"
      [taskUsers]="taskUsers()"
      [visibility]="mobileVisibility()"
      [touchUi]="layout() === 'mobile'"
    />
  } @else {
    <proffeo-task-details-wide-metadata
      (statusSelected)="onStatusSelected($event)"
      (progressSelected)="onPercentageChange($event)"
      (prioritySelected)="onPrioritySelected($event)"
      (industryRequested)="onIndustryClicked()"
      (locationRequested)="onLocationClicked()"
      (openTimeReportRequested)="openTimeReportClicked()"
      (timeReportsTabRequested)="timeReportsTabClicked()"
      (startDateSelected)="onTaskStartDateSelected($event)"
      (endDateSelected)="onTaskEndDateSelected($event)"
      (estimationSelected)="onEstimationSelected($event)"
      (groupRequested)="onChangeGroupClicked()"
      (participantsRequested)="onChangeParticipantsClicked()"
      (tagsRequested)="openTaskTagsEditor()"
      [task]="task()"
      [tags]="tags()"
      [taskUsers]="taskUsers()"
    />
  }
  <proffeo-ui-divider />
</div>
